import "./estilo.css"
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Result } from "antd";
import { applyPrintToken } from "./printAuth";

/**
 * Wraps a print-only page (`/print/cotizacion/:id`, `/print/informe/:id`).
 * Reads the short-lived JWT from the `token` query param and applies it via
 * `applyPrintToken` BEFORE rendering children, so any API call a child
 * fires from its own effects is already authenticated by the time it runs
 * — see printAuth.js for why localStorage is the correct mechanism here.
 *
 * These routes must NOT redirect to /login when there's no app session
 * (see App.js: print paths bypass the normal Entry/`authed` gate
 * entirely) — they authenticate purely via this URL token instead.
 */
const PrintGate = ({ children }) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    applyPrintToken(token);
    setReady(true);
  }, [token]);

  if (!token) {
    return (
      <Result
        status="warning"
        title="Falta el token de acceso"
        subTitle="Esta página solo puede visitarse a través de un enlace de impresión válido."
      />
    );
  }

  if (!ready) {
    return null;
  }

  return children;
};

export default PrintGate;
